import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {IncidentRecord, IncidentSearchParams} from "../../../../NIBINInterface";
import {DropdownService} from "../../../../services/dropdown.service";
import {IncidentService} from "../../../../services/incident.service";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-rpt-modify-import-incident',
  templateUrl: './rpt-modify-import-incident.component.html',
  styleUrls: ['./rpt-modify-import-incident.component.css'],
  providers: [DropdownService, IncidentService]
})
export class RptModifyImportIncidentComponent implements OnInit {
  dataSource:IncidentRecord[] = [];
  constructor(private incidentService: IncidentService) { }

  @Output('IncidentSelected') IncidentSelected = new EventEmitter<IncidentRecord>()

  ngOnInit(): void {
  }

  async searchIncidents(params:IncidentSearchParams): Promise<void> {
    this.dataSource = await this.incidentService.searchIncidents(params);
  }

  SelectedForReport(incident:IncidentRecord) {
    this.IncidentSelected.emit(incident)
  }

}
